var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"workspaces-push"},_vm._l((_vm.workspaces),function(workspace){return _c('AxPushNotificationsWorkspace',{key:workspace.id,attrs:{"workspace":workspace},on:{"comments-changed":function($event){return _vm.workspaceCommentsChanged($event, workspace)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }